import React from "react";
import Navbar, { Nav } from "../../nav/Navbar";
import Brand from "../../brand/Brand";
import MenuContent from "./MenuContent";
import SelectorLanguage from "../../../SelectorLanguage";
import { useTranslation } from "react-i18next";

const menuContent = [
    { name: "Accueil", to: "/" },
    { name: "À propos", to: "/about" },
    { name: "Services", to: "/services" },
    { name: "Réalisations", to: "/portfolio" },
    { name: "Production Vidéo", to: "/video-production" },
    { name: "Blog", to: "/blog" },
    { name: "Contacts", to: "/contact" }
];

const DroowMenu = ({ hamburger }) => {
    const { t } = useTranslation("common");

    let $key = 0;
    const getSubMenu = (items) => {
        $key++;
        if (items.dropdownMenu) {
            return (
                <Nav.Dropdown name={items.name} key={$key}>
                    {items.dropdownMenu.map((item) => getSubMenu(item))}
                </Nav.Dropdown>
            );
        }
        return (
            <Nav.Link to={items.to} key={$key}>
                {t(items.name)}
            </Nav.Link>
        );
    };

    return (
        <Navbar hamburger={hamburger}>
            <Navbar.Brand to={"/"}>
                <Brand width="140px" height="140px" />
            </Navbar.Brand>
            <SelectorLanguage />
            <Navbar.Collapse cover="Menu">
                <Nav>
                    {menuContent.map((item) => getSubMenu(item))}
                </Nav>
                <MenuContent className="section-margin" />
            </Navbar.Collapse>
        </Navbar>
    );
};

DroowMenu.defaultProps = {
    hamburger: false
};

export default DroowMenu;
